import React, { Component } from 'react'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { Row, Col, Modal, Popconfirm, message, Upload, Icon, Skeleton, Empty } from 'antd'
import { graphql, Query } from 'react-apollo'
import gql from 'graphql-tag'
import { compose } from 'recompose'
import moment from 'moment'
import { RoleCode } from '../../../constants'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			selectedPhotos: []
		}

		this.handleDeleteAttachment = this.handleDeleteAttachment.bind(this)
	}

	handleDeleteAttachment (event_uid, file_uid) {
		const { deleteAttachment } = this.props

		message.loading({ key: 'delete_attachment', content: 'Deleting Attachment, please wait..' })
		deleteAttachment({ event_uid, file_uid }).then((response) => {
			message.success({ key: 'delete_attachment', content: 'Attachment successfully deleted.' })
		}).catch(err => {
			console.log('error deleting attachment')
			message.error({ key: 'delete_attachment', content: err.message.replace('GraphQL error:', '') })
		})
	}

	render() {
		const { selectedPhotos } = this.state
		const { AuthStore, visible, onCancel, event_uid } = this.props
		const { user_type } = AuthStore
		const isAdmin = (_.isEqual(user_type, RoleCode.SYSTEMADMIN) || _.isEqual(user_type, RoleCode.SUPERADMIN))

		const uploadButton = (
			<div>
			  <Icon type={'plus'} />
			  <div className="ant-upload-text">Upload Photos</div>
			</div>
		)

		var that = this
		const fileProps = {
			name: 'file',
			multiple: true,
			onChange(info) {
				const { fileList } = info
				that.setState({ selectedPhotos: fileList })
				if (_.isEqual(info.file.status, 'removed')) {
					console.log('file removed', info.file)
					if (_.has(info.file, 'fromServer') && info.file.fromServer) {
						that.handleDeleteAttachment(info.file.event_uid, info.file.uid)
					}
				}
			},
			beforeUpload (file, fileList) { return false },
			showUploadList: true,
			accept: 'image/jpeg, image/png',
			listType: 'picture-card'
		}
		return (
			<Modal
				title='View Event Details'
				width='75%'
				visible={visible}
				onCancel={onCancel}
				destroyOnClose
				footer={null}
			>
				<Query
					query={EVENT_BY_UID}
					variables={{ event_uid }}
					fetchPolicy='network-only'
				>
					{({ loading, error, data }) => {
						if (loading) return <Skeleton active/>
						if (error) return <Empty/>

						const event = _.has(data, 'eventByUid') ? data.eventByUid : {}
						const attachments = event.attachments.map((attachment) => {
							return {
								original: `${process.env.REACT_APP_BACKEND_API}${attachment.url}`,
								thumbnail: `${process.env.REACT_APP_BACKEND_API}${attachment.url}`
							}
						})

						let defaultFileList = event.attachments.map((attachment, key) => {
							return {
								uid: attachment._pivot_file_uid,
								event_uid: attachment._pivot_event_uid,
								name: attachment.originalname,
								status: 'done',
								url: `${process.env.REACT_APP_BACKEND_API}${attachment.url}`,
								fromServer: true
							}
						})
						return (
							<React.Fragment>
								<Row>
									<Col md={12} sm={24}>
										<img 
											src={event.thumbnail_url ? 
												`${process.env.REACT_APP_BACKEND_API}${event.thumbnail_url}` : 
												'/assets/images/events-placeholder.png'} 
											width={500}
											height='auto'
										/>
									</Col>
									<Col md={12} sm={24}>
										<Row>
											<Col md={24} sm={24}>
												<Row gutter={16}>
													<Col md={10} sm={24}>
														<h4 style={{ color: 'gray' }}>Event Name</h4>
													</Col>
													<Col md={14} sm={24}>
														<h4>{event.name}</h4>
													</Col>
												</Row>
											</Col>
											<Col md={24} sm={24}>
												<Row gutter={16} style={{ marginTop: 10 }}>
													<Col md={10} sm={24}>
														<h4 style={{ color: 'gray' }}>Start At</h4>
													</Col>
													<Col md={14} sm={24}>
														<h4>{moment(event.from_date).format('lll')}</h4>
													</Col>
												</Row>
											</Col>
											<Col md={24} sm={24}>
												<Row gutter={16} style={{ marginTop: 10 }}>
													<Col md={10} sm={24}>
														<h4 style={{ color: 'gray' }}>End At</h4>
													</Col>
													<Col md={14} sm={24}>
														<h4>{moment(event.to_date).format('lll')}</h4>
													</Col>
												</Row>
											</Col>
											<Col md={24} sm={24}>
												<Row gutter={16} style={{ marginTop: 10 }}>
													<Col md={10} sm={24}>
														<h4 style={{ color: 'gray' }}>Remarks</h4>
													</Col>
													<Col md={14} sm={24}>
														<h4>{event.remarks}</h4>
													</Col>
												</Row>
											</Col>
											<Col md={24} sm={24}>
												<Row gutter={16} style={{ marginTop: 10 }}>
													<Col md={10} sm={24}>
														<h4 style={{ color: 'gray' }}>Created At</h4>
													</Col>
													<Col md={14} sm={24}>
														<h4>{moment(event.created_at).format('lll')}</h4>
													</Col>
												</Row>
											</Col>
											<Col md={24} sm={24}>
												<Upload defaultFileList={defaultFileList} {...fileProps}>
													{uploadButton}
												</Upload>
											</Col>
										</Row>
									</Col>
								</Row>
								{
									(attachments.length > 0) &&
									<Row style={{ marginTop: 20 }}>
										<legend>Photo Attachments</legend>
										<ImageGallery items={attachments} />
									</Row>
								}
								<Row style={{ marginTop: 50 }}>
									{
										isAdmin &&
										<Popconfirm
											title="Are you sure delete this event?"
											onConfirm={() => {
												const { deleteEvent } = this.props
												deleteEvent({ event_uid: event.uid })
													.then((response) => {
														message.success('Event successfully deleted.')

														//create audit trail
														const auditParams = {
															module_name: 'Events',
															action: 'Delete',
															message: `Deleted event ${event.name}`
														}
														AuthStore.saveAuditTrail(auditParams)
														onCancel()
													}).catch(err => {
														console.log('error deleting event', err)
														message.error(err.message.replace('GraphQL error:', ''))
													})
											}}
											// onCancel={cancel}
											okText="Yes"
											cancelText="No"
										>
											<button style={{ float: 'left' }} type="button" className="btn btn-danger btn-rounded waves-effect waves-light">Delete event?</button>
										</Popconfirm>
									}
									{	
										(selectedPhotos.length > 0) &&
										<button 
											style={{ float: 'right' }} 
											type="button" 
											className="btn btn-primary btn-rounded waves-effect waves-light"
											onClick={() => {
												const { uploadEventPhoto } =  this.props
				
												const formattedFiles = selectedPhotos.map((mFile) => mFile.originFileObj).filter((i) => i !== undefined)
												const params = {
													event_uid: event.uid,
													files: formattedFiles
												}
												
												uploadEventPhoto(params).then(response => {
													message.success('Photo(s) successfully uploaded')
												})
												.catch(err => {
													console.log('error uploading photos', err)
													message.error(err.message.replace('GraphQL error:', ''))
												})
											}}
										>
											Upload Photos
										</button>
									}
								</Row>
							</React.Fragment>
						)
					}}
				</Query>
				
			</Modal>
		)
	}
}

const EVENT_BY_UID = gql`
    query eventByUid($event_uid: String) {
		eventByUid(event_uid: $event_uid)
    }
`

const DELETE_EVENT = gql`
    mutation deleteEvent($input: JSON) {
		deleteEvent(input: $input)
    }
`

const UPLOAD_PHOTO = gql`
    mutation uploadEventPhoto($input: JSON) {
		uploadEventPhoto(input: $input)
    }
`

const DELETE_EVENT_ATTACHMENT = gql`
    mutation deleteEventAttachment($input: JSON) {
		deleteEventAttachment(input: $input)
    }
`

const composed = compose(
	inject('AuthStore'),
	graphql(DELETE_EVENT, {
		props({ mutate }) {
			return {
				deleteEvent(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['eventByDate']
					})
				}
			}
		}
	}),
	graphql(UPLOAD_PHOTO, {
		props({ mutate }) {
			return {
				uploadEventPhoto(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['eventByUid']
					})
				}
			}
		}
	}),
	graphql(DELETE_EVENT_ATTACHMENT, {
		props({ mutate }) {
			return {
				deleteAttachment(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['eventByUid']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)